import React, {Component } from 'react';
import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";

import global from "../data/global.json";
import Highlight from "./Highlight";
import Tooltip from "./Tooltip";
import Gif from "./Gif";
import Video from "./Video";
import Menu from "./Menu";
import MiniTour from "./MiniTour";
import DragDrop from "./DragDrop";
import ComponentRenderer from "./ComponentRenderer";
import uuid from "uuid/v4";
import { withScenePosition } from "../scenePosition";
import Button from "./Button";
import {withRouter} from "react-router-dom";

class Hotspot extends Component {

  constructor(props){
    super(props);

    this.onClick =  this.onClick.bind(this);;
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.setHoverFalse = this.setHoverFalse.bind(this);

    this.hoverTimer = undefined;

    this.state = {
      open: false,
      hover: false,
      width: undefined,
      height:undefined,
      activated: false,
      hidden: false,
      id:  uuid()
    };
  }

  onClick(e){
    let { dispatch, to, history, menuState, menu, step, steps, highlight, button, minitour } = this.props;
    let { hasSteps, id, tabIndex, tabId } = this.state;

    if(to !== undefined) {
      history.push(to);
      e.stopPropagation();
      return false;
    }

    if(highlight !== undefined && highlight.to !== undefined) {
      history.push(highlight.to);
      e.stopPropagation();
      return false;
    }

    if(button !== undefined && button.to !== undefined) {
      history.push(button.to);
      e.stopPropagation();
      return false;
    }

    if(menuState.open){
      this.closeMenu();
      e.stopPropagation();
      return false;
    }

    if(menu && menu.id){
      this.openMenu(menu.id);
      e.stopPropagation();
      return false;
    }

    if(minitour && minitour.id){
      this.startMinitour(minitour.id);

      e.stopPropagation();
      return false;
    }

    if(tabIndex !== undefined && tabId !== undefined){
      dispatch({
        type: "tab/ACTIVATE_TAB",
        payload: {
          id: tabId,
          index: tabIndex
        }
      });
      e.stopPropagation();
      return false;
    }

    if((step.started || hasSteps) && (!highlight || !highlight.noClick)){
      dispatch({
        type: "scene/ACTIVATE_HOTSPOT",
        payload: id
      });

      if(step.started) {
        if(step.index + 1 >= step.steps.length) {
          dispatch({
            type: "step/FINISH"
          });

        } else {
          dispatch({
            type: "step/NEXT"
          });

          this.setState({
            activated: false,
            open: false
          });
        }
      } else {
        let {dispatch} = this.props;
        dispatch({
          type: "step/START",
          payload: {
            steps: steps,
            id: this.state.id
          }
        });

        this.setState({
          activated: true
        });
      }
    }
  }

  openMenu(id){
    let { dispatch } = this.props;
    dispatch({
      type: "menu/ACTIVATE_MENU",
      payload: id
    });
  }

  startMinitour(id){
    let { dispatch } = this.props;
    dispatch({
      type: "minitour/START",
      payload: id
    });
    dispatch({
      type: "step/OVERRIDE_TOP",
      payload: id
    });
  }

  onMouseOver(e){
    let isHotspot = e.target.className.indexOf("hotspot") > -1;
    let isHighlight = e.target.className.indexOf("highlight") > -1;
    let isTooltip = e.target.className.indexOf("tooltip") > -1;
    let isHoverButton = e.target.className.indexOf("button") > -1 || e.target.tagName === "EM" || e.target.tagName === "I";

    if(isHighlight){
      clearTimeout(this.hoverTimer);
    }

    if(isHoverButton){
      clearTimeout(this.hoverTimer);
    }

    if(isHotspot) {
      this.setState({
        hover: true
      });
      document.addEventListener("click", this.setHoverFalse, {once: true});
    }

    if(isTooltip) {
      clearTimeout(this.hoverTimer);
    }
  }

  onMouseOut(e){
    let isHotspot = e.target.className.indexOf("hotspot") > -1;
    let isHighlight = e.target.className.indexOf("highlight") > -1;
    let isTooltip = e.target.className.indexOf("tooltip") > -1;
    let isHoverButton = e.target.className.indexOf("button") > -1;

    if(isHotspot || isHighlight || isHoverButton || isTooltip){
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout((() => {
        this.setHoverFalse();
      }), 20);
    }
  }

  setHoverFalse() {
    this.setState({
      hover: false
    })
  }

  closeMenu(){
    let { dispatch } = this.props;
    dispatch({
      type: "menu/DEACTIVATE_MENU"
    });
  }

  static getDerivedStateFromProps(props, state){
    let { steps, step, clickable, highlight, menuState, menu, minitour } = props;

    let { open, activated } = state;

    let  { top, left, width, height} =  props;

    // close all open steps when another one is activated
    if(!step.started && (step.started !== activated) && step.index === 0){
      open = false;
      activated  = false;
    }

    let tabIndex = highlight && highlight.tabIndex !== undefined ? highlight.tabIndex : undefined;

    let tabId = highlight && highlight.tabId !== undefined ? highlight.tabId : undefined;

    const hasSteps = steps && steps.length > 0;
    const hasMinitour = !!minitour;

    return {
      ...state,
      hasLink: props.to !== undefined,
      left: left,
      top: top,
      width: width,
      height: height,
      hasSteps: steps && steps.length > 0,
      hasMinitour: hasMinitour,
      tabIndex: tabIndex,
      tabId: tabId,
      open: open,
      activated: activated,
      menuOpen: menu && menuState.open && menuState.id === menu.id,
      clickable: hasSteps || clickable
    }
  }

  getBackgroundImagePath(filename) {
    return `${window.public_url}/images/scenes/background-images/${filename}`
  }

  render() {

    const { top, left, width, height, open, hasSteps, hover, activated, tabIndex, tabId } = this.state;
    const { step, steps, highlight, tooltip, gif, button, menu, minitourState, minitour, video, dragDrop, tabState, location} = this.props;

    let showContentClass = typeof step.stepId !== "undefined" && !!step.isTopLevel ? (step.stepId === this.state.id ? "show-content" : "hide-content") : "";
    if (!!minitour && (minitour.id === minitourState.minitourId || minitourState.prevId.indexOf(minitour.id) >= 0)) {
      showContentClass = "";
    }

    let isHotspotHidden = !!tabId && tabIndex === tabState.indexes.get(tabId);

    return (
      <div className={`hotspot-wrapper ${showContentClass}`}>
        {!hasSteps || (hasSteps && !step.started) ?

        <div className={`hotspot ${open ? 'open' : ''} ${hover ? 'hover': ''} ${isHotspotHidden ? 'hidden' : ' '} ${!!minitourState.isActive ? 'minitour-active' : ' '}`}
             data-id={this.state.id}
             style={{left, top, width, height}}
             onClick={(e)=>this.onClick(e)}
             onMouseOver={(e)=>this.onMouseOver(e)}
             onMouseOut={this.onMouseOut}>

          <div className="animation">
            <span className="hotspot-inner"/>
            <span className="hotspot-outer" />
          </div>

        </div> : undefined }

        {video ? (
          <Video {...video}></Video>
        ) : null}

        {dragDrop ? (
          <DragDrop {...dragDrop}></DragDrop>
        ) : null}

        {highlight ? (
          <Highlight {...highlight} hover={hover} onMouseOver={(e)=>this.onMouseOver(e)}  onMouseOut={(e)=>this.onMouseOut(e)} onClick={(e)=>this.onClick(e)} />
        ) : null}

        {tooltip ? (
          <Tooltip {...tooltip} hover={hover} steps={steps} onNext={(steps)=>this.onNextStep(steps)} onMouseOver={(e)=>this.onMouseOver(e)}  onMouseOut={(e)=>this.onMouseOut(e)}  onPrevious={this.onPreviousStep} location={location} />
        ) : null}

        {button ? (
          <Button {...button} hover={hover} onMouseOver={(e)=>this.onMouseOver(e)}  onMouseOut={(e)=>this.onMouseOut(e)} onClick={(e)=>this.onClick(e)}  />
        ) : null}

        {step.started && hasSteps && activated ?
          (
            <div className={!!steps[step.index].raiseZ ? "raise-z steps" : "steps"}>
              <img alt="background" className="step-background" src={this.getBackgroundImagePath(steps[step.index].backgroundImage)}/>
              <ComponentRenderer components={steps[step.index].components} />
            </div>
          ) : undefined
        }

        {gif ? (
          <Gif {...gif}></Gif>
        ) : null}

        {menu ? (
          <Menu {...menu}>
            <Highlight open={true} {...highlight} onClick={(e)=>this.onClick(e)} />
          </Menu>
        ) : null}

        {minitour && minitourState.isActive && (minitour.id === minitourState.minitourId || minitourState.prevId.indexOf(minitour.id) >= 0) ? (
          <MiniTour {...minitour} location={location} onClick={(e)=>this.onClick(e)}>
            <img alt="background" className="step-background" src={this.getBackgroundImagePath(minitour.backgroundImage)}/>
            <ComponentRenderer components={minitour.components} />
          </MiniTour>
        ) : null}

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    menuState: state.menu,
    minitourState: state.minitour,
    tabState: state.tab
  }
}

Hotspot.defaultProps = {
  clickable: false
}

export default withRouter(windowSize(connect(mapStateToProps)(withScenePosition(Hotspot, {w: global.hotspotSize.width, h: global.hotspotSize.height}))));



// WEBPACK FOOTER //
// ./src/components/Hotspot.jsx